import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Approach from "@/pages/Approach";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-white px-6 text-center">
                    <div>
                        <p className="eyebrow text-brand">ELCAYIL CONSULTING LTD.</p>
                        <p className="mt-4 font-serif-d text-3xl">
                            Something went wrong.
                        </p>
                        <button
                            data-testid="error-reload-button"
                            className="mt-8 rounded-full border border-ink/20 px-6 py-3 text-sm hover:bg-ink hover:text-white transition-colors duration-300"
                            onClick={() => window.location.reload()}
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const SmoothScroll = ({ children }) => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
    return children;
};

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll>
                    <ScrollToTop />
                    <div className="grain" aria-hidden="true" />
                    <Nav />
                    <main className="elcayil-page">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/approach" element={<Approach />} />
                            <Route path="/insights" element={<Insights />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                </SmoothScroll>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
